import { ROLE } from './enum';

/**
 * Everything a Beacon user may open. Beacon is an identity, not a capability:
 * the role gates a whole product area, so this list is the gate rather than any
 * permission the role happens to hold.
 *
 * Its own three pages plus the support form. /team, /invite and /tickets were
 * on this list and are deliberately not any more — a Beacon user administers
 * nobody and raises support through /contact-support.
 */
export const BEACON_ALLOWED_PATHS = [
  '/beacon',
  '/beacon-live',
  '/aeo-query',
  '/contact-support',
];

/** Matches a path with or without the leading encrypted client id. */
export const isBeaconAllowedPath = (pathname: string): boolean => {
  const parts = pathname.split('/').filter(Boolean);
  const clientScoped = parts.length > 1 ? `/${parts.slice(1).join('/')}` : pathname;
  return BEACON_ALLOWED_PATHS.some(
    (allowed) =>
      pathname === allowed ||
      pathname.startsWith(`${allowed}/`) ||
      clientScoped === allowed ||
      clientScoped.startsWith(`${allowed}/`)
  );
};

/** Whether this role is confined to the Beacon area. */
export const isBeaconRole = (role?: string | null): boolean =>
  role?.toUpperCase() === ROLE.BEACON;
